(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-navigation-item-with-dropdown"] && !Shopify.designMode) return;
  try {
    function initHeaderDropdowns() {
  const dropdownItems = document.querySelectorAll('.header__nav-item.with-dropdown');

  function updateAriaExpanded(el, open) {
    const link = el.querySelector('.header__nav-link');
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  dropdownItems.forEach(item => {
    if (item.dataset.dropdownInit) return;
    item.dataset.dropdownInit = 'true';

    const trigger = item.querySelector('.header__nav-link');
    const isInMobileNav = item.closest('.header__mobile-nav') !== null;

    if (isInMobileNav) {
      // Mobilní overlay – vždy toggle na klik
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const isOpen = item.classList.contains('with-dropdown--open');
        item.classList.toggle('with-dropdown--open', !isOpen);
        updateAriaExpanded(item, !isOpen);
      });
    } else {
      // Desktopová navigace – hover + klik pro touch zařízení
      let openTimeout, closeTimeout;

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          dropdownItems.forEach(i => {
            if (i.closest('.header__mobile-nav')) return;
            i.classList.remove('with-dropdown--open');
            updateAriaExpanded(i, false);
          });
          item.classList.add('with-dropdown--open');
          updateAriaExpanded(item, true);
        }, 125);
      });

      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(() => {
          item.classList.remove('with-dropdown--open');
          updateAriaExpanded(item, false);
        }, 125);
      });

      trigger.addEventListener('click', function (e) {
        if (!window.matchMedia('(hover: none)').matches) return;
        e.preventDefault();
        e.stopPropagation();
        const isOpen = item.classList.contains('with-dropdown--open');
        dropdownItems.forEach(i => {
          if (i.closest('.header__mobile-nav')) return;
          i.classList.remove('with-dropdown--open');
          updateAriaExpanded(i, false);
        });
        if (!isOpen) {
          item.classList.add('with-dropdown--open');
          updateAriaExpanded(item, true);
        }
      });
    }
  });

  if (!window.__headerDropdownOutsideClickBound) {
    window.__headerDropdownOutsideClickBound = true;
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.header__nav-item.with-dropdown--open').forEach(item => {
        if (item.closest('.header__mobile-nav')) return;
        if (!item.contains(e.target)) {
          item.classList.remove('with-dropdown--open');
          updateAriaExpanded(item, false);
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderDropdowns);
} else {
  initHeaderDropdowns();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordions"] && !Shopify.designMode) return;
  try {
    const accordions = document.querySelectorAll('.accordion');
accordions.forEach(accordion => {
    const header = accordion.querySelector('.accordion__header');
    const icon = header.querySelector('i');
    header.addEventListener('click', () => {
        accordion.classList.toggle('accordion--open');
        const isOpen = accordion.classList.contains('accordion--open');
        header.setAttribute('aria-expanded', isOpen);
        if (icon.classList.contains('fa-plus')) {
            icon.classList.replace('fa-plus', 'fa-minus');
        } else {
            icon.classList.replace('fa-minus', 'fa-plus');
        }
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-toggle]').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const item = toggle.closest('[data-faq-item]');
            item.classList.toggle('open');
            const isOpen = item.classList.contains('open');
            toggle.setAttribute('aria-expanded', isOpen);
        });
        toggle.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle.click();
            }
        });
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slider__wrapper').forEach(slider => {
    const content = slider.querySelector('.slider__content');
    const btnLeft = slider.querySelector('.slider__arrow--left');
    const btnRight = slider.querySelector('.slider__arrow--right');

    if (!content || !btnLeft || !btnRight) return;

    function updateArrows() {
      const maxScrollLeft = content.scrollWidth - content.clientWidth - 1;
      const atStart = content.scrollLeft <= 1;
      const atEnd = content.scrollLeft >= maxScrollLeft;

      slider.querySelector('.slider').classList.toggle('slider--scrolled-to-end', atEnd);
      slider.querySelector('.slider').classList.toggle('slider--scrolled-to-start', atStart);

      if(atStart) {
        btnRight.classList.remove('slider__arrow--disabled');
        btnLeft.classList.add('slider__arrow--disabled');
      }
      else if(atEnd) {
        btnRight.classList.add('slider__arrow--disabled');
        btnLeft.classList.remove('slider__arrow--disabled');
      }
      else {
        btnRight.classList.remove('slider__arrow--disabled');
        btnLeft.classList.remove('slider__arrow--disabled');
      }
    }

    btnLeft.addEventListener('click', () => {
      const itemWidth = content.querySelector(':scope > *')?.offsetWidth || content.clientWidth;
      content.scrollBy({ left: -itemWidth - parseInt(getComputedStyle(content).gap), behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
      const itemWidth = content.querySelector(':scope > *')?.offsetWidth || content.clientWidth;
      content.scrollBy({ left: itemWidth + parseInt(getComputedStyle(content).gap), behavior: 'smooth' });
    });

    let resizeTimer;
    content.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateArrows, 150);
    });

    updateArrows();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".tabs-wrapper").forEach(wrapper => {
      const nav = wrapper.querySelector(".tabs-nav");
      const content = wrapper.querySelector(".tabs-content");

      // Move trigger buttons from content into nav
      content.querySelectorAll(":scope > .tab-button").forEach(btn => {
        nav.appendChild(btn);
      });

      const buttons = nav.querySelectorAll(".tab-button");
      const panels = content.querySelectorAll(".tab-panel");

      // Activate first tab
      if (buttons[0]) {
        buttons[0].classList.add("active");
        buttons[0].setAttribute("aria-selected", "true");
        buttons[0].setAttribute("role", "tab");
        buttons[0].setAttribute("tabindex", "0");
      }
      if (panels[0]) {
        panels[0].classList.add("active");
        panels[0].setAttribute("role", "tabpanel");
      }

      buttons.forEach(button => {
        button.setAttribute("role", "tab");
        if (!button.classList.contains("active")) {
          button.setAttribute("tabindex", "-1");
          button.setAttribute("aria-selected", "false");
        }

        button.addEventListener("click", () => {
          const targetId = "tab-" + button.dataset.tab;

          buttons.forEach(btn => {
            btn.classList.remove("active");
            btn.setAttribute("aria-selected", "false");
            btn.setAttribute("tabindex", "-1");
          });
          panels.forEach(panel => {
            panel.classList.remove("active");
          });

          button.classList.add("active");
          button.setAttribute("aria-selected", "true");
          button.setAttribute("tabindex", "0");

          const panel = document.getElementById(targetId);
          if (panel) {
            panel.classList.add("active");
          }
        });

        button.addEventListener("keydown", (e) => {
          const btns = Array.from(buttons);
          const idx = btns.indexOf(button);
          let newIdx = idx;
          if (e.key === "ArrowRight") newIdx = (idx + 1) % btns.length;
          else if (e.key === "ArrowLeft") newIdx = (idx - 1 + btns.length) % btns.length;
          else return;
          e.preventDefault();
          btns[newIdx].click();
          btns[newIdx].focus();
        });
      });

      panels.forEach(panel => panel.setAttribute("role", "tabpanel"));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
